function announcebar(){
  var defaults = {
    container: '.announce-inr',
    sections: 'li',
    duration: 5000,
    loop: true,
    currentClass: 'current',
    direction: 'up'
  };
  var opts = {};
  var container;
  var sections;
  var iIndex = 0;
  var content;
  var contentHeight;
  var contentChildHeight;
  var temp;
  var currentClass;
  var arrElements = [];
  var intervalID;
  var duration;
  function scrollText(options) {
    opts = Object.assign({}, defaults, options || {});
    container = document.querySelector(opts.container);
    sections = container.querySelectorAll(opts.sections);
    sections.forEach(function (item) {
      arrElements.push(item);
    });
    var ul = container.querySelector('ul');
    ul.classList.add('ulzone');
    content = document.querySelector('.ulzone');
    contentHeight = content.offsetHeight;
    contentChildHeight = content.children[0].offsetHeight;
    temp = contentChildHeight;
    duration = opts.duration;
    currentClass = opts.currentClass;
    // Clone the first child and append it to the end
    var firstChildClone = content.children[0].cloneNode(true);
    content.appendChild(firstChildClone);
    initLayout(container);
  }
  function up() {
    content.style.transition = 'margin-top 1s';
    content.style.marginTop = '-' + contentChildHeight + 'px';
    arrElements.forEach(function (el) {
      el.classList.remove(currentClass);
    });
    iIndex += 1;
    if (iIndex >= arrElements.length) {
      iIndex = 0;
    }
    arrElements[iIndex].classList.add(currentClass);
    if (contentChildHeight >= contentHeight) {
      setTimeout(function() {
        content.style.transition = 'none';
        content.style.marginTop = '0';
        contentChildHeight = temp;
      }, 1000);
    } else {
      contentChildHeight += temp;
    }
  }
  function initLayout(t) {
    var clone = content.cloneNode(true);
    content.parentNode.appendChild(clone);
    handleStyle(t);
    scroll();
  }
  function handleStyle(t) {
    arrElements = t.querySelectorAll('li');
    arrElements[iIndex].classList.add(currentClass);
  }
  function scroll() {
    if (intervalID) {
      clearInterval(intervalID);
    }
    intervalID = setInterval(up, duration);
  }
  function handleVisibilityChange() {
    if (document.hidden) {
      clearInterval(intervalID);
    } else {
      scroll();
    }
  }
  function setupVisibilityChangeHandling() {
    if (typeof document.hidden !== "undefined") {
      document.removeEventListener("visibilitychange", handleVisibilityChange, false);
      document.addEventListener("visibilitychange", handleVisibilityChange, false);
    }
  }
  setupVisibilityChangeHandling();
  document.addEventListener('DOMContentLoaded', function () {
    scrollText({
      duration: 3000,
      loop: true
    });
  });
}
announcebar();